import { useRef, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import styles from './AIInput.module.css';

export interface AIInputProps {
  onSubmit: (text: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
}

export const AIInput: React.FC<AIInputProps> = ({ onSubmit, disabled, autoFocus }) => {
  const ref = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState('');
  const canSend = value.trim().length > 0 && !disabled;

  const grow = (el: HTMLTextAreaElement) => {
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 200)}px`;
  };

  const submit = () => {
    if (!canSend) return;
    onSubmit(value.trim());
    setValue('');
    if (ref.current) ref.current.style.height = 'auto';
  };

  return (
    <div className={cn(styles.field, disabled && styles.disabled)}>
      <textarea
        ref={ref}
        className={styles.textarea}
        rows={1}
        autoFocus={autoFocus}
        placeholder="Опишите ваш вопрос"
        value={value}
        disabled={disabled}
        onChange={(e) => {
          setValue(e.target.value);
          grow(e.target);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
      />
      <button
        type="button"
        className={styles.send}
        aria-label="Отправить"
        disabled={!canSend}
        onClick={submit}
      >
        <ArrowUp size={20} strokeWidth={2.5} />
      </button>
    </div>
  );
};
